export default __webpack_public_path__ + "static/media/arrow-right-black.8142f592.svg";